import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// const firebaseConfig = {
//   apiKey: "AIzaSyDLT-5-SQzlKJx0cxcNk6aCvzvxT_rj3Tw",
//   authDomain: "connectsu-service.firebaseapp.com",
//   projectId: "connectsu-prod",
//   storageBucket: "connectsu-service.appspot.com",
//   messagingSenderId: "237290583102",
//   appId: "1:237290583102:web:77cb775a471da40c838d6f",
//   measurementId: "G-0T2PT3QGJY",
// };

// const prodFirebaseConfig = {
//    apiKey: "AIzaSyApvIHs-vk_B6ADl99_8fekR5NGi1n73fc",
//   authDomain: "connectsu-service.firebaseapp.com",
//   projectId: "connectsu-prod",
//   storageBucket: "connectsu-service.appspot.com",
//   messagingSenderId: "237290583102",
//   appId: "1:237290583102:web:77cb775a471da40c838d6f",
//   measurementId: "G-0T2PT3QGJY",
// }

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain:process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket:  process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId:  process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId:  process.env.REACT_APP_MEASUREMENT_ID,
};


// const firebaseConfigToUse = process.env.REACT_APP_ENVIRONMENT === 'production' ? prodFirebaseConfig : firebaseConfig;


const app = initializeApp(firebaseConfig)

const firebaseAuth = getAuth(app);
export default firebaseAuth;
